import { lazy } from 'react';
import { RouteConfig } from '../../types/routing.types';
import { Activity } from 'lucide-react';

const MetricsDashboard = lazy(() => import('./components/MetricsDashboard'));

export const metricsRoutes: RouteConfig[] = [
  {
    path: '/metrics/*',
    component: MetricsDashboard,
    label: 'Métriques',
    icon: Activity,
    showInNav: true,
    breadcrumb: ['Accueil', 'Métriques'],
  },
];
